<app-header />
<router-outlet></router-outlet>

<ng-container *ngIf="loginService.showLoginDialog">
    <app-login class="expired-session" />
</ng-container>
